var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recent-actions"},[_c('div',{staticClass:"search"},[_c('tol-type-ahead',{attrs:{"search-params":{
        url: "/event-log/user-activity",
        searchKeys: ['searchParam'],
        urlParams: {
          recordsPerPage: _vm.userActivityPageLimit,
          offset: _vm.userActivityOffset,
          sortBy: _vm.userActivitySortOrder,
          sortDirection: _vm.userActivitySortDirection
        }
      },"results-in-dropdown":false,"menu-label":"Search user activity logs"},on:{"filtered":function($event){return _vm.onFiltered($event)}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }